<template>
  <div id="app" class="app-container">
    <div class="container">
      <TheMenuBar v-if="$route.name !== 'Login'" />
      <div class="right-content">
        <TheHeader v-if="$route.name !== 'Login'" />
        <router-view></router-view>
      </div>
    </div>
    <TheFooter v-if="$route.name !== 'Login'" />
  </div>
</template>

<script>
import TheHeader from './components/TheHeader.vue';
import TheFooter from './components/TheFooter.vue';
import TheMenuBar from './components/TheMenuBar.vue';
import "@/assets/styles/Common.css";

export default {
  name: 'App',
  components: {
    TheHeader,
    TheFooter,
    TheMenuBar
  }
};
</script>

<style>
/* 共通スタイル */

.form-container {
    padding: 15px;
    border-radius: 8px;
    background-color: #d4f1c5;
    font-size: 16px;
    margin: 0 auto;
    overflow-y: auto; /* 縦にスクロール可能 */
    height: calc(100vh - 150px); /* 例えばマージンやヘッダー分を差し引いて高さを調整 */
}

body, html {
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
  font-family: 'Noto Sans JP', sans-serif;
  background-color: #d4f1c5;
  color: #333;
  line-height: 1.5;
}

h1, h2, h3, h4, h5, h6 {
  font-weight: 700;
  color: #212121;
}

h1 {
  font-size: 2.0em;
  line-height: 1;
}

h2 {
  font-size: 1.5em;
  line-height: 1.2;
}

p, a, li {
  font-size: 1em;
  line-height: 0.4;
  white-space: nowrap;
}

a {
  color: #0077c2;
  text-decoration: none;
  transition: color 0.2s ease;
}

a:hover {
  color: #005a8f;
}

/* 全体のレイアウト */
.app-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.container {
  flex: 1;
  display: flex;
  height: calc(100vh - 50px);
}

.right-content {
  flex: 1;
  overflow-y: auto;
  height: 100%;
}

</style>